import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-muted-foreground text-xs" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogTrigger,
        DialogBody,
    } from '@/components/ui/dialog';
    import { ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import FileUploadZone from '../FileUploadZone.vue';
    import CreateButton from '@/components/CreateButton.vue';
    import { Alert } from '@/components/ui/alert';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'UploadBiReport',
  setup(__props) {

    const queryClient = useQueryClient();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const open = ref(false);
    const uploadedFile = ref([]);

    const { t } = useI18n();

    const handleClose = () => {
        uploadedFile.value = [];
        open.value = false;
    };

    const handleSuccess = () => {
        toast.success(t('forms.general.success'));
        queryClient.invalidateQueries({ queryKey: [QueryKey.POWER_BI, selectedCompanyId.value] });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(CreateButton, { "button-text": "power_bi.upload_power_bi_report" })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('power_bi.upload_power_bi_report')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, [
                _createTextVNode(_toDisplayString(_unref(t)('bi_and_companies.csv_headers_needed')) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-bold" }, " reporting account, reporting account nr, accounts in mapping, measurement calculation ", -1))
              ]),
              _createVNode(_unref(Alert), { variant: "warning" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('bi_and_companies.csv_import_warning')), 1)
                ]),
                _: 1
              }),
              _createVNode(FileUploadZone, {
                modelValue: uploadedFile.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadedFile).value = $event)),
                "accepts-files": ['.csv'],
                "instant-upload": "",
                route: _ctx.route('v2.powerbi.setup.upload'),
                "max-uploads": 1,
                onSuccess: handleSuccess
              }, null, 8, ["modelValue", "route"])
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})